import { render, staticRenderFns } from "./AppointmentManager.vue?vue&type=template&id=0c7d0dd8"
import script from "./AppointmentManager.vue?vue&type=script&lang=js"
export * from "./AppointmentManager.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports